module.exports = __webpack_public_path__ + "img/joseph-lister.4aa66cc9.png";